import axios from "axios";
const baseURL = "/api";
axios.defaults.baseURL = baseURL;
// 查询学院公告列表
export const getNocticeList = params => {
  return axios
    .post(`/course/manage/announcement/query/list`, params)
    .then(res => res.data);
};
// 查询学院公告详情
export const getNocticeMain = params => {
  return axios
    .post(`/course/manage/announcement/query`, params)
    .then(res => res.data);
};
//班级详情接口
export const getClassMain = params => {
  return axios
    .post(`/course/manage/homepage/class/detail`, params)
    .then(res => res.data);
};
//课程播发课程列表
export const getCourseList = params => {
  return axios
    .post(`/course/manage/homepage/course/detail`, params)
    .then(res => res.data);
};
//通过vid查询视频信息
export const getVideoUrl = params => {
  return axios
    .post(`/course/manage/homepage/class/course/section/watch/info`, params)
    .then(res => res.data);
};
//通过vid查询公开课视频信息
export const getPublicVideoUrl = params => {
  return axios
    .post(`/course/manage/homepage/open/course/section/watch/info`, params)
    .then(res => res.data);
};
//证书视频想i详情
export const getPublicVideoUrlVideoInfo = params => {
  return axios.post(`/course/video/play/info`, params).then(res => res.data);
};
//查询班级学院列表
export const getClassStundent = params => {
  return axios
    .post(`/course/manage/homepage/class/student/list`, params)
    .then(res => res.data);
};
//查询学院动态列表
export const getNewsList = params => {
  return axios
    .post(`/course/manage/homepage/org/dynamic/query`, params)
    .then(res => res.data);
};
//投诉建议
export const suggest = (params, callback) => {
  return axios
    .post(`/course/identify/suggest/create`, params, callback)
    .then(res => res.data);
};
//更换密码发送手机验证码
export const passVerifyCode = (params, callback) => {
  return axios
    .post(`/uc/resetpassword/send/phone/verifycode`, params, callback)
    .then(res => res.data);
};
//更换密码
export const updatePassword = (params, callback) => {
  return axios
    .post(`/uc/resetpassword/phone`, params, callback)
    .then(res => res.data);
}; //获取用户信息
export const getUser = params => {
  return axios.get(`/uc/identify/user/baseinfo`, params).then(res => res.data);
};
//提交用户信息
export const getUserData = params => {
  return axios.post(`/uc/update/info`, params).then(res => res.data);
};
//上传图片
export const getFileUpload = (params, callback) => {
  return axios
    .post(`/third/api/huaWeiUpload/upload/image`, params, callback)
    .then(res => res.data);
};
//用户订单管理
export const getOrder = (params, callback) => {
  return axios
    .post(`/order/identify/orderContro/find-user`, params, callback)
    .then(res => res.data);
};
//用户取消订单
export const cancelOrder = (params, callback) => {
  return axios
    .post(`/order/identify/orderContro/cancelOrder-user`, params, callback)
    .then(res => res.data);
};
//更换手机号发送验证码
export const ucVerifyCode = (params, callback) => {
  return axios
    .post(`/uc/identify/reset/phone/send/verify/code`, params, callback)
    .then(res => res.data);
};
//更换手机号发送验证码
export const ucChangePhone = (params, callback) => {
  return axios
    .post(`/uc/identify/reset/phone/check/verify/code`, params, callback)
    .then(res => res.data);
};
//更换手机号
export const ChangePhone = (params, callback) => {
  return axios
    .post(`/uc/identify/reset/phone`, params, callback)
    .then(res => res.data);
};
//学习记录
export const courseupdate = params => {
  return axios
    .post(`/course/identify/learncentre/study/record/update`, params)
    .then(res => res.data);
};
//是否管理员
export const isAdmin = params => {
  return axios.post(`/course/manage/auth/query`, params).then(res => res.data);
};
//班级公告创建
export const classNewsAdd = params => {
  return axios
    .post(`/course/manage/proscenium/classannouncement/create`, params)
    .then(res => res.data);
};
//班级公告查询
export const classNews = params => {
  return axios
    .post(`/course/manage/proscenium/classannouncement/query/list`, params)
    .then(res => res.data);
};
//班级公告编辑
export const editNews = params => {
  return axios
    .post(`/course/manage/proscenium/classannouncement/edit`, params)
    .then(res => res.data);
};
//加入学院的详情
export const joinDetail = params => {
  return axios.post(`/course/org/join/detail`, params).then(res => res.data);
};
//加入学院
export const joinCollege = params => {
  return axios
    .post(`/course/manage/org/join/invitecode`, params)
    .then(res => res.data);
};
//直播中心列表
export const liveList = params => {
  return axios
    .post(`/course/userLive/findLiveRoom/byPage`, params)
    .then(res => res.data);
};
//根据liveId查询直播间信息
export const getLiveMsg = params => {
  return axios
    .post(`/course/userLive/findLiveRoom/byLiveId`, params)
    .then(res => res.data);
};

//直播记录学习记录
export const liveUpdate = params => {
  return axios
    .post(`/course/identify/learncentre/study/record/live/update`, params)
    .then(res => res.data);
};
//获取观看人数
export const getUserList = params => {
  return axios
    .post(`/course/identify/learncentre/live/online/user`, params)
    .then(res => res.data);
};
//加入群聊
export const getJoinChat = params => {
  return axios.post(`/course/userLive/addImRoom`, params).then(res => res.data);
};

//im查询用户
export const getSearchUser = params => {
  return axios
    .post(`/course/identify/im/user/query/by/imaccount`, params)
    .then(res => res.data);
};
//课件目录
export const attachList = params => {
  return axios
    .post(`/course/manage/homepage/course/attach/list`, params)
    .then(res => res.data);
};
//打卡
export const punchClock = params => {
  return axios
    .post(`/course/identify/learncentre/punch/clock`, params)
    .then(res => res.data);
};
//班级评论
export const sendCreateMsg = params => {
  return axios
    .post(`/course/manage/class/comment/create`, params)
    .then(res => res.data);
};
//班级评论
export const getCreateMsg = params => {
  return axios
    .post(`/course/manage/class/comment/query/page`, params)
    .then(res => res.data);
};
//班级点赞
export const commentLike = params => {
  return axios
    .post(`/course/manage/class/comment/like`, params)
    .then(res => res.data);
};

//班级单元测试已结束
export const classTestEnd = params => {
  return axios
    .post(`/course/manage/exam/mine/record`, params)
    .then(res => res.data);
};

//班级单元测试待测试
export const classTestWait = params => {
  return axios
    .post(`/course/manage/trainPlan/exam/list`, params)
    .then(res => res.data);
};
//待开始问卷
export const effectiveList = params => {
  return axios
    .post(`/course/identify/survey/query/effective/survey/list`, params)
    .then(res => res.data);
};
//已结束问卷
export const closedList = params => {
  return axios
    .post(`/course/identify/survey/query/closed/survey/list`, params)
    .then(res => res.data);
};
//问卷详情
export const questionnaireDetails = params => {
  return axios
    .post(`/course/identify/survey/query/details`, params)
    .then(res => res.data);
};
//问卷提交
export const questionnaireSubmit = params => {
  return axios
    .post(`/course/identify/survey/submit`, params)
    .then(res => res.data);
};
//校验系统时间
export const timestamp = params => {
  return axios
    .post(`/course/identify/learncentre/current/timestamp`, params)
    .then(res => res.data);
};
//续约单点登录key
export const singlePointRenewal = params => {
  return axios
    .post(`/course/manage/homepage/singlePointRenewal`, params)
    .then(res => res.data);
};
//首页直播中心
export const liveCenter = params => {
  return axios
    .post(`/course/userLive/liveCenter`, params)
    .then(res => res.data);
};
//绑定微信
export const bindWxCode = params => {
  return axios
    .post(`/uc/identify/wxmp/bind/wx/scan/code`, params)
    .then(res => res.data);
};

//实名认证
export const examineIdCardImg = params => {
  return axios
    .post(`/course/user/certification/examineIdCardImg`, params)
    .then(res => res.data);
};
//实名状态
export const checkStatus = params => {
  return axios
    .post(`/course/user/certification/checkStatus`, params)
    .then(res => res.data);
};

//实名用户重置手机号
export const resetMobile = params => {
  return axios
    .post(`/course/manage/user/center/reset/user/mobile`, params)
    .then(res => res.data);
};
//视频信息
export const courseVideoPlayInfo = params => {
  return axios.post(`/course/video/play/info`, params).then(res => res.data);
};

//证书列表分类
export const getcertificateCategory = params => {
  return axios
    .post(`/course/product/cert/category`, params)
    .then(res => res.data);
};
//证书列表
export const searchCertificateList = params => {
  return axios
    .post(`/course/product/cert/search`, params)
    .then(res => res.data);
};

//证书课程播放
export const certTrainCourseDetail = params => {
  return axios
    .post(`/course/user/certPrivate/getCertTrainCourseDetail`, params)
    .then(res => res.data);
};

//证书课程播放学习记录
export const privateCert = params => {
  return axios
    .post(
      `/course/identify/learncentre/study/record/update/privateCert`,
      params
    )
    .then(res => res.data);
};

//证书搜索
export const searchCertificate = params => {
  return axios
    .post(`/course/product/cert/search`, params)
    .then(res => res.data);
};
export const selfExamData = params => {
  return axios
    .post(`/course/user/certPrivate/getAppointCertPage`, params)
    .then(res => res.data);
};

//证书班级详情
export const certClassDetail = params => {
  return axios
    .post(`/course/user/certPrivate/getCertTrainCourse`, params)
    .then(res => res.data);
};
//证书课程详情
export const publicCoursePlayDetail = params => {
  return axios
    .post(`/course/identify/user/cert/class/course/detail`, params)
    .then(res => res.data);
};

//证书上传图片 、文件
export const getCertFileUpload = params =>
  axios.post(`/third/api/huaWeiUpload/upload/img`, params); //上传图片

export const certUploadData = params => {
  return axios
    .post(`/course/user/certPrivate/saveOrUpdateAppointRecord`, params)
    .then(res => res.data);
};
export const dataDetail = params => {
  return axios
    .post(`/course/user/certPrivate/getAppointRecord`, params)
    .then(res => res.data);
};
export const downloadTempate = params => {
  return axios
    .post(`/course/user/certPrivate/download/tempate`, params)
    .then(res => res.data);
};

//证书通知公告
export const announcement = params => {
  return axios
    .post(`/course/identify/class/cert/announcement/query/noPage`, params)
    .then(res => res.data);
};
//证书通知公告浏览
export const announcementLook = params => {
  return axios
    .post(`/course/identify/class/cert/announcement/view/handle`, params)
    .then(res => res.data);
};
//证书通知公告详情
export const announcementDetail = params => {
  return axios
    .post(`/course/identify/class/cert/announcement/detail/query`, params)
    .then(res => res.data);
};
//证书评论
export const certCreateMsg = params => {
  return axios
    .post(`/course/identify/class/cert/comment/create`, params)
    .then(res => res.data);
};
//证书评论
export const getCertMsg = params => {
  return axios
    .post(`/course/identify/class/cert/comment/page`, params)
    .then(res => res.data);
};
//证书资料
export const certTicket = params => {
  return axios
    .post(`/course/user/certPrivate/getCertTrainResult`, params)
    .then(res => res.data);
};
//证书成绩
export const achievement = params => {
  return axios
    .post(`/course/user/certPrivate/getCertTrainResult`, params)
    .then(res => res.data);
};

//证书成绩
export const lookExamTime = params => {
  return axios
    .post(`/course/user/certPrivate/findExamTime`, params)
    .then(res => res.data);
};

//评价
//查看班级评论列表
export const getRateList = params => {
  return axios
    .post(`/course/uc/evaluate/record/getPage`, params)
    .then(res => res.data);
};

//新增班级评价
export const setRecordRate = params => {
  return axios
    .post(`/course/uc/evaluate/record/save`, params)
    .then(res => res.data);
};

//获取人脸合身验证地址
export const createFaceCode = params => {
  return axios
    .post(`/course/identify/tencent/face/e/eidtoken/sh`, params)
    .then(res => res.data);
};
//轮训人脸核验结果
export const checkEidTokenStatus = params => {
  return axios
    .post(`/course/identify/tencent/face/e/checkEidTokenStatus/sh`, params)
    .then(res => res.data);
};

//【E证通】学员信息【上海试岗】
export const faceStudentInfo = params => {
  return axios
    .post(`/course/identify/tencent/face/e/student/info/sh`, params)
    .then(res => res.data);
};
//【E证通】学员姓名修改【上海试岗】
export const faceStudentNameUpdate = params => {
  return axios
    .post(`/course/identify/tencent/face/e/student/name/update/sh`, params)
    .then(res => res.data);
};

//保存地址信息
export const saveExpressInfo = params => {
  return axios
    .post(`/course/user/certPrivateExpress/saveExpressInfo`, params)
    .then(res => res.data);
};

//获取地址信息
export const getExpressInfo = params => {
  return axios
    .post(`/course/user/certPrivateExpress/getExpressInfo`, params)
    .then(res => res.data);
};
//用户token有效时间   token
export const getUserExpireTime = params => {
  return axios
    .post(`/course/identify/user/token/expireTime`, params)
    .then(res => res.data);
};
//上海活跃打卡   token
export const activeClock = params => {
  return axios
    .post(`/course/identify/sh/active/clock/slider`, params)
    .then(res => res.data);
};
//上海活跃打卡失败   token
export const activeError = params => {
  return axios
    .post(`/course/identify/sh/active/error`, params)
    .then(res => res.data);
};
//上海
export const shNeedCheck = params => {
  return axios
    .post(`/course/identify/sh/need/check`, params)
    .then(res => res.data);
};

export const classCommentEdit = params => {
  return axios
    .post(`/course/manage/class/comment/edit/comment`, params)
    .then(res => res.data);
};
export const singlePointCheck = params => {
  return axios
    .post(`/course/manage/homepage/singlepoint/check`, params)
    .then(res => res.data);
};

export const liveBackVedioList = params => {
  return axios
    .post(`/course/live/play/back/clip/user/list`, params)
    .then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/api.js